var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBackGuaranteeCheckoutIcon = function SvgMoneyBackGuaranteeCheckoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "money-back-guarantee-checkout-icon_svg__b",
    x1: "32.998%",
    y1: "-10.088%",
    y2: "83.136%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F4F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "money-back-guarantee-checkout-icon_svg__a",
    cx: 11.5,
    cy: 9.5,
    r: 6.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.345
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#AA4DC8",
    xlinkHref: "#money-back-guarantee-checkout-icon_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#money-back-guarantee-checkout-icon_svg__b)",
    xlinkHref: "#money-back-guarantee-checkout-icon_svg__a"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#AA4DC8",
    fontFamily: "HelveticaNeueW01-65Medium, Helvetica Neue W01 65 Medium",
    fontSize: 10
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 13
  }, "1")), /*#__PURE__*/React.createElement("text", {
    fill: "#AA4DC8",
    fontFamily: "HelveticaNeueW01-65Medium, Helvetica Neue W01 65 Medium",
    fontSize: 10
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11,
    y: 13
  }, "4")), /*#__PURE__*/React.createElement("path", {
    fill: "#AA4DC8",
    fillRule: "nonzero",
    d: "M18.179 2.783A9.637 9.637 0 0 0 11.369 0a9.62 9.62 0 0 0-6.896 2.868.51.51 0 0 0 .009.725.528.528 0 0 0 .734-.009 8.588 8.588 0 0 1 6.153-2.557c4.74-.004 8.594 3.798 8.594 8.473 0 4.675-3.854 8.477-8.594 8.477-4.74 0-8.594-3.802-8.594-8.477v-.107l.856.844a.524.524 0 0 0 .734 0 .507.507 0 0 0 0-.724L2.628 7.795a.524.524 0 0 0-.734 0L.152 9.513a.507.507 0 0 0 0 .724c.203.2.532.2.735 0l.855-.844V9.5a9.375 9.375 0 0 0 2.822 6.717A9.637 9.637 0 0 0 11.374 19c2.57 0 4.99-.989 6.809-2.783A9.371 9.371 0 0 0 21 9.5a9.375 9.375 0 0 0-2.821-6.717Z"
  }))));
};
export default SvgMoneyBackGuaranteeCheckoutIcon;